import { Outlet } from "react-router-dom";
import { PaymentsList } from "./payments-list";

export function PaymentsLayout() {
	return (
		<>
			<PaymentsList />
			<Outlet />
		</>
	);
}
